import { Box } from "@material-ui/core";
import React, { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";

import { PREFECTURES } from "@/api/options/account";
import { RegistrationPhases } from "@/components/registration/RegistrationPhases";
import { NumberInputField } from "@/components/selection/NumberEntry";
import { PickerField } from "@/components/selection/PickerField";
import { useGetMasterResidenceTypes } from "@/hooks/useGetMasterData";
import { RegistrationFlowLayout, RegistrationActions } from "@/layouts/RegistrationFlowLayout";
import { AccountRegisterFormData } from "@/validations/account";

interface RegisterResidencePageProps {
  totalSteps: number;
  currentStep: number;
  onNext: () => void;
  onBack: () => void;
  validate: () => Promise<boolean>;
}
const RegisterResidencePage: FC<RegisterResidencePageProps> = ({ onNext, onBack, validate }) => {
  const { control, errors } = useFormContext<AccountRegisterFormData>();
  const residenceType = useWatch({
    control,
    name: "current_residence_type_id",
    defaultValue: control.getValues("current_residence_type_id"),
  });
  const { masterResidenceTypes } = useGetMasterResidenceTypes();
  return (
    <RegistrationFlowLayout
      phaseTags={<RegistrationPhases completed />}
      title="お住まいについて"
      description="住宅ローンの有無で、購入できる価格帯が変わります"
    >
      <Box>
        <Controller
          name="address_prefecture"
          control={control}
          render={(field) => (
            <PickerField
              {...field}
              row
              label="お住まいの地域"
              options={PREFECTURES.map((value) => ({ value, label: value }))}
              searchable
              error={errors.address_prefecture?.message}
            />
          )}
        />
        <Controller
          name="current_residence_type_id"
          control={control}
          render={(field) => (
            <PickerField
              {...field}
              row
              label="お住まいの家"
              options={masterResidenceTypes.map((type) => ({ value: type.id, label: type.name }))}
              error={errors.current_residence_type_id?.message}
            />
          )}
        />
        {residenceType === 1 && (
          <Controller
            name="home_loan_amount"
            control={control}
            render={(field) => (
              <NumberInputField
                {...field}
                label="住宅ローン残債"
                unit="万円"
                error={errors.home_loan_amount?.message}
              />
            )}
          />
        )}
        {residenceType === 2 && (
          <Controller
            name="monthly_rent_payment_amount"
            control={control}
            render={(field) => (
              <NumberInputField {...field} label="家賃" unit="円" error={errors.monthly_rent_payment_amount?.message} />
            )}
          />
        )}
      </Box>
      <RegistrationActions
        onNext={async () => {
          if (await validate()) onNext();
        }}
        onBack={onBack}
      />
    </RegistrationFlowLayout>
  );
};
export default RegisterResidencePage;
